import './Icon.scss';

import { b2x } from '@b2x/react/src';

export const iconsNames = [] as const;
export type IconName = typeof iconsNames[number];

export type IconSize = 16;

export interface IconProps extends b2x.IconProps<IconName, IconSize> {}

export const Icon = (props: IconProps) => <b2x.Icon {...props} />;

export const isIconName = (name?: string): name is IconName => b2x.isIconName(iconsNames, name);
